import { render, staticRenderFns } from "./AutocompleteOption.vue?vue&type=template&id=0220a5ce&scoped=true"
import script from "./AutocompleteOption.vue?vue&type=script&lang=js"
export * from "./AutocompleteOption.vue?vue&type=script&lang=js"
import style0 from "./AutocompleteOption.vue?vue&type=style&index=0&id=0220a5ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0220a5ce",
  null
  
)

export default component.exports